import { makeNoteMockData } from '../../modules/noteMockDataFactory'
import type { ICaseNote } from '~/types/note/models'

/**
 * A case's notes. Unlike most note collections this one is SEEDED, so the
 * Case page's Notes card has a row to show beside the Emails card.
 *
 * ⚠ Only notes. Until cynque-api-server #1737 this also held each email's
 * readable text, authored by Case Bot; that text is the email's `body` now
 * (api/msw/api/caseEmails/mockData.ts), and those five rows are gone.
 */
export async function getStartingCaseNoteListData(): Promise<ICaseNote[]> {
  return [
    // Typed in the app by a person.
    {
      id: 'XXCAN0001',
      hrid: 'CAN0001',
      case: { id: 'XXCA0001', label: 'POTS line at Boston dropping calls' },
      descr: 'Customer call: intermittent dial tone',
      note:
        'Customer called about intermittent dial tone on the Boston POTS ' +
        'line. Opened a case and asked them to email details.',
      enteredByTeamMember: { id: 'XXTM0006', label: 'Service Technician' },
      status: { id: 1, label: 'Open' },
      createdAt: '2022-03-01T13:45:00Z',
      // ⚠ Differs from createdAt deliberately, so the Notes card shows an
      // edited note. No mock module stamps `modifiedAt` on a PATCH the way the
      // server does (`modified_at` defaults to now() on the entity base), so
      // without this the edited state could not be produced by clicking either.
      modifiedAt: '2022-03-04T09:12:00Z',
      version: '1',
      canBeDeleted: true,
    },
    // Created BEFORE the note above and edited AFTER it, so the Notes card's
    // newest-edited-first order differs both from the order served here and
    // from newest-created-first.
    {
      id: 'XXCAN0002',
      hrid: 'CAN0002',
      case: { id: 'XXCA0001', label: 'POTS line at Boston dropping calls' },
      descr: 'Carrier ticket opened',
      note:
        'Opened a trouble ticket with the carrier for the Boston POTS line; ' +
        'updated with their reference once they replied.',
      enteredByTeamMember: { id: 'XXTM0006', label: 'Service Technician' },
      status: { id: 1, label: 'Open' },
      createdAt: '2022-02-28T15:20:00Z',
      modifiedAt: '2022-03-05T11:30:00Z',
      version: '1',
      canBeDeleted: true,
    },
  ]
}

export const {
  getNoteListData: getCaseNoteListData,
  getNoteDataById: getCaseNoteDataById,
  getNoteListDataByParentId: getCaseNoteListDataByCaseId,
} = makeNoteMockData<ICaseNote>({
  entityName: 'case',
  storageKeyPrefix: 'case',
  getStartingListData: getStartingCaseNoteListData,
})
